const scLevels = [
    {id: 0, name: '拼音'},
    {id: 1, name: 'Level 1'},
    {id: 2, name: 'Level 2'},
    {id: 3, name: 'Level 3'},
    {id: 4, name: 'Level 4'},
    {id: 5, name: 'Level 5'},
    {id: 6, name: 'Level 6'},
    {id: 7, name: 'Level 7'},
    {id: 8, name: 'Level 8'},
    {id: 9, name: 'Level 9'},
    {id: 10, name: 'Level 10'},
    {id: 11, name: 'Level 11'},
    {id: 12, name: 'Level 12'},
];
export const state = {
    courses: [
        {id: 0, name: 'SC课程'},
        {id: 2, name: '华师大课程'},
        {id: 3, name: 'AI频道'},
        {id: 4, name: '行业汉语'},
        {id: 6, name: '发展汉语'},
    ],
    levels: scLevels,
    courseLevels: {
        0: scLevels,
        1: scLevels,
        2: [
            {id: 201, name: 'Level 1'},
            {id: 202, name: 'Level 2'},
            {id: 203, name: 'Level 3'},
            {id: 204, name: 'Level 4'},
            {id: 205, name: 'Level 5'},
            {id: 206, name: 'Level 6'},
        ],
        3: [
            {id: 301, name: '初级'},
            {id: 302, name: '中级'},
        ],
        4: [
            {id: 401, name: 'Level 1'},
        ],
        6: [
            {id: 601, name: 'Level 1'},
            {id: 602, name: 'Level 2'},
            {id: 603, name: 'Level 3'},
        ]
    },
    pinyinTypes: [
        {id: 0, name: '默认', category: 0},
        {id: 1, name: '声调1', category: 1},
        {id: 2, name: '声调2', category: 1},
        {id: 3, name: '声母', category: 2},
        {id: 4, name: '单韵母', category: 3},
        {id: 5, name: '复韵母', category: 3},
        {id: 6, name: 'a+b/p/m/f/d/t/n/l', category: 4},
        {id: 7, name: 'o+b/p/m/f/d/t/n/l', category: 4},
        {id: 8, name: 'e+g/k/h', category: 4},
        {id: 9, name: 'i+j/q/x', category: 4},
        {id: 10, name: 'u+zh/ch/sh/r/z/c/s', category: 4},
        {id: 11, name: 'ü+j/q/x/n/l', category: 4},
        {id: 12, name: 'y/w', category: 4},
        {id: 13, name: '变调', category: 4},
        {id: 14, name: '双音节', category: 4},
        {id: 15, name: '拼音总表', category: 5},
    ],
    pinyinGroups: [
        {id: 'intro', name: '介绍'},
        {id: 'tones', name: '声调'},
        {id: 'tones1', name: '声调1'},
        {id: 'tones2', name: '声调2'},
        {id: 'initials', name: '声母'},
        {id: 'initials1', name: '声母1'},
        {id: 'initials2', name: '声母2'},
        {id: 'initials3', name: '声母3'},
        {id: 'initialstest', name: '声母小测试'},
        {id: 'finals1', name: '单韵母'},
        {id: 'finals2', name: '复韵母'},
        {id: 'finals01', name: '韵母1'},
        {id: 'finals02', name: '韵母2'},
        {id: 'finals03', name: '韵母3'},
        {id: 'finals04', name: '韵母4'},
        {id: 'finalstest', name: '韵母小测试'},
        {id: 'a+', name: 'a+b/p/m/f/d/t/n/l'},
        {id: 'o+', name: 'o+b/p/m/f/d/t/n/l'},
        {id: 'e+', name: 'e+g/k/h'},
        {id: 'i+', name: 'i+j/q/x'},
        {id: 'i2+', name: 'i+zh/ch/sh/r/z/c/s'},
        {id: 'u+', name: 'u+zh/ch/sh/r/z/c/s'},
        {id: 'u2+', name: 'ü+j/q/x/n/l'},
        {id: 'yw', name: 'y/w'},
        {id: 'bd', name: '变调'},
        {id: 'syj', name: '双音节'},
        {id: 'test', name: '小测试'}
    ],
    pinyinCombTypes: [
        {id: 'pinyin', title: '拼音'},
        {id: 'pyword', title: '字词'},
        {id: 'pyintro', title: '介绍'},
    ],
    pinyinCombLayouts: [
        {id: 'list', title: '列表'},
        {id: 'list:1', title: '列表(有间距)'},
        {id: 'list:2', title: '列表(横线分隔)'},
        {id: 'list:3', title: '列表(无间距)'},
        {id: 'grid:1', title: '网格1'},
        {id: 'grid:2', title: '网格2'},
        {id: 'grid:3', title: '网格3'},
        {id: 'grid:31', title: '网格31'},
        {id: 'grid:2232', title: '网格2232'},
        {id: 'grid:2113', title: '网格2113'}
    ],
    knows: [],
    knowsId: null,
    currentCourseId: 0,
    currentLevel: 0,
    currentLessonId: 0,
    expand: false,
}

export const getters = {
    levels(state) {
        return state.courseLevels[state.currentCourseId] || [];
    },
    getLevels: (state) => (course_id) => {
        return state.courseLevels[course_id] || [];
    },
    getPinyinType: (state) => (id) => {
        return state.pinyinTypes.find(n => n.id === id)
    },
    getPinyinGroup: (state) => (id) => {
        return state.pinyinGroups.find(n => n.id === id)
    },
    getPinyinCombType: (state) => (id) => {
        return state.pinyinCombTypes.find(n => n.id === id)
    },
    getPinyinComnLayout: (state) => (id) => {
        return state.pinyinCombLayouts.find(n => n.id === id)
    },
    getCourseId(state) {
        return state.currentCourseId === null || state.currentCourseId === '' ? undefined : state.currentCourseId;
    },
    getLevel: (state) => (id) => {
        return state.levels.find(n => n.id === id)
    },
    currentLevel: (state) => {
        return state.currentLevel
    },
    currentLessonId: (state) => {
        return state.currentLessonId
    }
}

export const mutations = {
    initKnow(state, items) {
        state.knows = items
    },
    updateKnows(state, payload) {
        if (state.knows.length === 0 || payload.id !== state.knowsId) {
            state.knows = payload.items
            state.knowsId = payload.id
        } else {
            state.knows = state.knows.concat(payload.items)
        }
    },
    addKnow(state, item) {
        state.knows.push(item)
    },
    clearKnows(state) {
        state.knows = []
    },
    updateCurrentCourse(state, course_id) {
        state.currentCourseId = course_id
    },
    updateCurrentLevel(state, level) {
        state.currentLevel = level
    },
    updateCurrentLessonId(state, lid) {
        state.currentLessonId = lid
    }
}